module.exports = __webpack_public_path__ + "static/media/vilnius-16.ae5e1be1.jpg";